import React from "react";
import { FunctionField, ReferenceField, useRecordContext } from "react-admin";
import { isEmpty } from "lodash";

interface IUpdatedByField {
  data: IUpdatedBy;
  record?: any;
  referenceSource?: string;
}

const UpdatedByField = ({
  data,
  record = {},
  referenceSource = "updatedBy.id",
}: IUpdatedByField) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;

  if (data) {
    switch (data.role) {
      case "Parent":
        return (
          <ReferenceField
            reference="parents"
            source={referenceSource}
            link={false}
            record={records}
          >
            <FunctionField
              render={(record: any) =>
                `${data.role} - ${record.firstName} ${record.lastName}`
              }
            />
          </ReferenceField>
        );

      case "Admin":
      case "Superadmin":
        return (
          <ReferenceField
            reference="admins"
            source={referenceSource}
            link={false}
            record={records}
          >
            <FunctionField
              render={(record: any) => `${data.role} - ${record.fullName}`}
            />
          </ReferenceField>
        );

      case "Driver":
        return (
          <ReferenceField
            reference="drivers"
            source={referenceSource}
            linkType={false}
            record={records}
          >
            <FunctionField
              render={(record: any) => `${data.role} - ${record.fullName}`}
            />
          </ReferenceField>
        );

      case "Assistant":
        return (
          <ReferenceField
            reference="busAssistants"
            source={referenceSource}
            linkType={false}
            record={records}
          >
            <FunctionField
              render={(record: any) => `Bus Assistant - ${record.fullName}`}
            />
          </ReferenceField>
        );

      default:
        return <>{data.role}</>;
    }
  }

  return <></>;
};

export default UpdatedByField;
